import { computed, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { type CanMatchFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { ConfigStore } from '../stores';

export const optionsPageCanMatch: CanMatchFn = () => {
  const configStore = inject(ConfigStore);
  const router = inject(Router);
  const redirect = router.parseUrl('/citation');
  const configState = computed(() => ({
    loaded: configStore.loaded(),
    error: configStore.error(),
  }));

  if (configStore.loaded()) {
    return configStore.features.optionsPage() ? true : redirect;
  }

  if (!configStore.loading()) {
    configStore.load();
  }

  return toObservable(configState).pipe(
    filter(({ loaded, error }) => loaded || error !== null),
    take(1),
    map(({ loaded }) => (loaded && configStore.features.optionsPage() ? true : redirect)),
  );
};
